module.exports = __webpack_public_path__ + "gi.svg?1afed1e43b3df70621911e848165db4f";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/gi.svg
// module id = 1120
// module chunks = 0